import React from "react";
import InputText from "../../components/inputs/InputText";

interface OtherSupplierFieldsProps {
  name?: string | null;
  phone?: string | null;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  /** Show the required-name error. */
  errors?: boolean;
  isDisable?: boolean;
  hint?: string;
}

/** Who the supplier actually is, shown when the Other supplier is picked. */
const OtherSupplierFields: React.FC<OtherSupplierFieldsProps> = ({
  name,
  phone,
  onChange,
  errors,
  isDisable,
  hint = "Other is for small, one-off suppliers. Enter who it is, so dues show who is owed.",
}) => (
  <div className="mt-3 rounded-lg border border-dashed border-slate-200 dark:border-slate-600 bg-slate-50/60 dark:bg-slate-700/30 p-3">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
      <InputText
        name="otherSupplierName"
        label="Supplier's name"
        required
        placeholder="e.g. Ravi Medicals"
        value={name ?? ""}
        onChange={onChange}
        isDisable={isDisable}
        errors={errors}
        errormessage="Enter who the supplier is"
      />
      <InputText
        name="otherSupplierPhone"
        label="Phone (optional)"
        type="tel"
        value={phone ?? ""}
        onChange={onChange}
        isDisable={isDisable}
      />
    </div>
    <p className="text-[10px] text-slate-400 dark:text-slate-500 mt-1">{hint}</p>
  </div>
);

export default React.memo(OtherSupplierFields);
